import React, { useState, useEffect, Fragment } from 'react';
import { Select, Cascader, Radio, Checkbox } from 'antd';
import { emptyFun } from '@untils/common';
import { selectProps } from './config';
import { connect } from 'dva';

const CombineSelect = props => {
  const {
    options: propsOptions = [],
    request = emptyFun,
    requestParams = {},
    searchHooks,
    searchObj = {},
    value: propsValue,
    onChange = emptyFun,
    type,
    dispatch,
    api,
    selectData,
    antdProps = {},
    openSearch = false,
    ifStore = '' //是否通过redux缓存下请求数据，为store时会缓存，在form中都不缓存
  } = props;

  const [options, setOptions] = useState(propsOptions);
  const [value, setValue] = useState(propsValue);
  const [isInit, setIsInit] = useState(true);

  const getDataSourceFormRedux = async () => {
    let optionData = [];

    // 处理异步多选下拉获取的数据存储在redux
    if (isInit && openSearch && type === 'select') {
      const { data = [] } = (await request({ ...searchObj, name: value, fillback: '1', ...requestParams })) || {};

      optionData = data.filter(({ is_show = '1' }) => is_show === '1');
    } else if (selectData[api] && selectData[api].length > 0) {
      optionData = selectData[api];
    } else {
      const { data = [] } = (!openSearch && (await request({...searchObj, ...requestParams}))) || {};

      if (data.length === 0) {
        return;
      }
      optionData = data.filter(({ is_show = '1' }) => is_show === '1');
      // 将请求数据放在store
      dispatch({
        type: 'selectData/save',
        payload: {
          [api]: optionData,
        },
      });
    }

    setOptions(optionData);
  };

  const getDataSource = async () => {
    let optionData = [];
    // 处理异步多选下拉

    if (isInit && openSearch && type === 'select') {
      const { data = [] } = (await request({ ...searchObj, name: value, fillback: '1', ...requestParams })) || {};

      optionData = data.filter(({ is_show = '1' }) => is_show === '1');
    } else {
      const { data = [] } = (!openSearch && (await request({...searchObj, ...requestParams}))) || {};

      if (data.length === 0) {
        return;
      }
      optionData = data.filter(({ is_show = '1' }) => is_show === '1');
      // 将请求数据放在store
      // dispatch({
      //   type: 'selectData/save',
      //   payload: {
      //     [api]: optionData,
      //   },
      // });
    }

    setOptions(optionData);
  };

  useEffect(() => {
    if(ifStore === 'store'){
      getDataSourceFormRedux();
    }else{
      getDataSource();
    }
    setIsInit(false);
  }, [searchHooks,ifStore]);

  useEffect(() => {
    setValue(propsValue);
  }, [propsValue]);

  const handleSearch = async val => {
    const { data = [] } = (await request({ ...searchObj, name: val })) || {};
    const optionData = data.filter(({ is_show = '1' }) => is_show === '1');

    dispatch({
      type: 'selectData/save',
      payload: {
        [api]: optionData,
      },
    });
    setOptions(optionData);
  };

  return (
    <Fragment>
      {type === 'radio' && <Radio.Group value={value} options={options} {...antdProps} onChange={onChange} />}
      {type === 'checkbox' && <Checkbox.Group value={value} options={options} {...antdProps} onChange={onChange} />}
      {type === 'select' && (
        <Select
          {...selectProps}
          value={value}
          options={options}
          onChange={onChange}
          {...antdProps}
          onSearch={openSearch && handleSearch}
        />
      )}
      {type === 'cascader' && (
        <Cascader
          {...antdProps}
          {...selectProps}
          value={value}
          options={options}
          onChange={onChange}
          changeOnSelect
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = state => {
  return { selectData: state.selectData };
};

export default connect(mapStateToProps)(CombineSelect);
